import { API, Item } from "@thenounproject/lingo-core";
import { createQueryAction } from "../actionCreators";
import { DEFAULT_PAGE_SIZE } from "../actionCreators/createQueryAction";

type Args = {
  itemId: string;
  version?: number;
};

type Result = { items: Item[]; total: number };
type NormalizedResult = { items: string[]; total: number };
const [useGalleryItems, fetchGalleryItems] = createQueryAction<Args, Result, NormalizedResult>(
  {
    entity: "items",
    action: "queryGallery",
    denormalize: {
      entity: null,
      items: {
        entity: "items",
        asset: "assets",
      },
    },
    pagingKey: "items",
    condition: ({ args }) => Boolean(args.itemId),
  },
  async ({ args: { itemId, version = 0 }, paging }) => {
    const res = await API.call<{ item: string }>({
      endpoint: `items/${itemId}`,
      method: "GET",
      query: {
        limit: DEFAULT_PAGE_SIZE,
        v: version,
        page: paging.page,
        include: "items",
      },
    });
    const item = res.entities.items[res.result.item];
    const items = item.items;
    return { result: { items, total: item.data.assets }, entities: res.entities };
  }
);

export default useGalleryItems;
export { fetchGalleryItems };
